import { Skeleton, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import * as React from 'react';
import { Link as LinkRouter, useParams } from 'react-router-dom';
import { usePayment } from '../../../api/PaymentsApi';
import {
	UI_CASH_MANAGEMENT_FEATURE_ENABLED,
	useAuthContext,
} from '../../../context/auth';
import {
	PAYMENTS_BREADCRUMBS__EDIT,
	PAYMENTS_BREADCRUMBS__NEW,
	PAYMENTS_PAGE__TITLE,
	PAYMENT_PAGE__TITLE,
} from '../data/constants';

interface ActiveLastBreadcrumbProps {
	loading?: boolean;
	isEdit?: boolean;
	isNew?: boolean;
}

export default function ActiveLastBreadcrumb(props: ActiveLastBreadcrumbProps) {
	const { loading, isEdit, isNew } = props;
	const params = useParams();
	const authData = useAuthContext();
	const authToken = authData.auth?.authorizationToken;
	const { paymentLocator } = params;
	const cashManagementEnabled =
		authData?.auth?.configProperties?.[UI_CASH_MANAGEMENT_FEATURE_ENABLED];

	const { data: payment } = usePayment(
		paymentLocator,
		authToken,
		cashManagementEnabled,
		authData?.hasPermission('payment.fetch'),
	);

	return loading ? (
		<Breadcrumbs aria-label='breadcrumb'>
			<Skeleton variant='text' width={300} />
		</Breadcrumbs>
	) : (
		<Breadcrumbs aria-label='breadcrumb'>
			<Link
				component={LinkRouter}
				underline='hover'
				color='inherit'
				to='/payments'
			>
				{PAYMENTS_PAGE__TITLE}
			</Link>
			{payment && (
				<Link
					component={LinkRouter}
					underline='hover'
					color='inherit'
					to={`/payments/${paymentLocator}`}
					aria-current='page'
				>
					{PAYMENT_PAGE__TITLE + ' ' + payment.displayId}
				</Link>
			)}
			{isEdit && (
				<Typography color='inherit'>{PAYMENTS_BREADCRUMBS__EDIT}</Typography>
			)}
			{isNew && (
				<Typography color='inherit'>{PAYMENTS_BREADCRUMBS__NEW}</Typography>
			)}
		</Breadcrumbs>
	);
}
